import styled, { useTheme } from 'styled-components';
import {
  MainContainer,
  Graphs,
  Tables,
  AudienceReport,
  MainContainerTV,
  MainContainerBVOD,
  Kpis,
} from 'components/Main/Main.styles';

import { ACdetails, useCampaignContext } from 'context/CampaignContext';
import { Add, TxtContainer2 } from 'components/Main/table/TableStyles';
import { StyledGraphContainer } from 'components/Main/graf/GraphStyles';
import TVKPIs from 'components/newSetup/TV/TVKPIs';
import { useDataSources } from 'customHooks/useDataSources';
import { useGetStoredQueriesDetails } from 'customHooks/useGetStoredQueriesDetails';
import { useTemplateContext } from 'context/TemplateContext';
import PlaceholderContainer from '../PlaceholderContainer';
import { useContext, useEffect, useState } from 'react';
import ReactLoading from 'react-loading';
import ClientPlaceholderContainer from '../CLIENTCOMPONENTS/ClientPlaceholderContainer';
import { PublishContext } from 'context/PublishContext';
import NoCampaignSelected from '../NoCampaignSelected';
import InputContext from 'context/InputContext';
import { useClientContext } from 'context/ClientContext';
import ARContainer from 'components/Main/Gallery/ARContainer';
import { IImageList, useImageList } from 'customHooks/useImageList';
import KPIComponent from '../KPIComponent';
import BVOD_KPI from './BVOD_KPI';

export const Alert = styled.div`
  position: absolute;
  top: 20%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50%;
  height: 50%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2;
  cursor: pointer;
  text-align: center;
  .text {
    position: absolute;
    top: 20%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 20px;
    color: white;
  }
`;

const TVmain = () => {
  const { activeSubCampaign, activeCampaign } = useCampaignContext();
  const { fetchedPlaceholders } = useTemplateContext();
  const newPlaceholder = undefined;
  const theme = useTheme();
  const [dataSources] = useDataSources(activeCampaign);
  const { publishedData } = useContext(PublishContext);

  // useEffect(() => {
  //     setUploadComponents(undefined)
  // }, [activeSubCampaign?.subcampaignId])

  const [storedQueries, , , , , , publishedQueries] = useGetStoredQueriesDetails(
    activeCampaign,
    newPlaceholder,
    fetchedPlaceholders,
    publishedData,
  );

  const { setCapture, videoDashboardView } = useContext(InputContext);
  const { anyCreate } = useClientContext();
  const isAgency = anyCreate;

  const componentIDs = [
    ['TV4.1', 'TV4.2', 'TV4.3', 'TV4.4', 'TV4.5'],
    ['TV5.1', 'TV5.2', 'TV5.3', 'TV5.4', 'TV5.5'],
    ['TV6.1', 'TV6.2', 'TV6.3', 'TV6.4', 'TV6.5'],
  ];

  const [uploadComponents, setUploadComponents] = useState<IImageList[][] | undefined>(undefined);
  const [list] = useImageList({ storedQueries: storedQueries, source: 'TV' });
  useEffect(() => {
    if (dataSources.length > 0) {
      setUploadComponents(list);
    } else {
      setUploadComponents(undefined);
    }
  }, [dataSources, list, activeSubCampaign]);

  const componentIDsBVOD = [
    ['BVOD3.1', 'BVOD3.2', 'BVOD3.3', 'BVOD3.4', 'BVOD3.5'],
    ['BVOD4.1', 'BVOD4.2', 'BVOD4.3', 'BVOD4.4', 'BVOD4.5'],
    ['BVOD5.1', 'BVOD5.2', 'BVOD5.3', 'BVOD5.4', 'BVOD5.5'],
  ];
  const [uploadComponentsBVOD, setUploadComponentsBVOD] = useState<IImageList[][] | undefined>(undefined);
  const [listBVOD] = useImageList({ storedQueries: storedQueries, source: 'BVOD' });
  useEffect(() => {
    if (dataSources.length > 0) {
      setUploadComponentsBVOD(listBVOD);
    } else {
      setUploadComponentsBVOD(undefined);
    }
  }, [dataSources, listBVOD, activeSubCampaign]);

  // Debug za pracenje videoDashboardView promjena
  return (
    <>
      {activeCampaign?.authorized && videoDashboardView === 'TV' && (
        <button className="PDFbutton" onClick={() => setCapture(true)}>
          Download PPT
        </button>
      )}
      {activeCampaign ? (
        <>
          {activeCampaign.authorized ? (
            <>
              {' '}
              <MainContainerTV dashboard={videoDashboardView} key={activeSubCampaign?.subcampaignId}>
                {activeSubCampaign?.subcampaignId !== -1 && storedQueries.length > 0 && dataSources.length > 0 ? (
                  <>
                    <TVKPIs></TVKPIs>

                    <Graphs dashboard={'TV'} columnsNumber={4}>
                      {storedQueries
                        .filter((el) => el?.position?.startsWith('TV1'))
                        .sort((a, b) => (Number(a.position) > Number(b.position) ? 1 : -1))
                        .map((e) => (
                          <PlaceholderContainer
                            key={e.position}
                            componentID={e.position as string}
                            placeholderId={e.position as string}
                            dataSources={dataSources}
                            storedQueryDetails={e}
                            isGraph={true}
                          ></PlaceholderContainer>
                        ))}
                    </Graphs>

                    <Graphs dashboard={'TV'} columnsNumber={2}>
                      {storedQueries
                        .filter((el) => el?.position?.startsWith('TV2'))
                        .sort((a, b) => (Number(a.position) > Number(b.position) ? 1 : -1))
                        .map((e) => (
                          <PlaceholderContainer
                            key={e.position}
                            componentID={e.position as string}
                            placeholderId={e.position as string}
                            dataSources={dataSources}
                            storedQueryDetails={e}
                            isGraph={true}
                          ></PlaceholderContainer>
                        ))}
                    </Graphs>

                    <Tables>
                      {storedQueries
                        .filter((el) => el?.position?.startsWith('TV3'))
                        .map((e) => (
                          <PlaceholderContainer
                            key={e.position}
                            componentID={e.position as string}
                            placeholderId={e.position as string}
                            dataSources={dataSources}
                            storedQueryDetails={e}
                            isGraph={false}
                          ></PlaceholderContainer>
                        ))}
                    </Tables>

                    {uploadComponents?.map((ids, index) => (
                      <AudienceReport key={index}>
                        {ids.map((id: any) => (
                          <ARContainer
                            key={id.id}
                            componentID={id.id}
                            oldComponentID={null}
                            visible={id.visible}
                            setUploadComponents={setUploadComponents}
                            uploadComponents={uploadComponents}
                          />
                        ))}
                      </AudienceReport>
                    ))}
                  </>
                ) : (
                  <StyledGraphContainer expand={0}>
                    <TxtContainer2 isGraph={false} displayTxt={0}>
                      <Add isGraph={true}>
                        <div style={{ paddingTop: '50%' }} className="text">
                          <ReactLoading className="loaderCentered" type="spinningBubbles" color={theme.publishButton} />
                          {activeSubCampaign?.subcampaignId === -1 &&
                            'There is no TV subcampaign associated with this campaign. Contact dk.support@annalect.com.'}
                        </div>
                      </Add>
                    </TxtContainer2>
                  </StyledGraphContainer>
                )}
              </MainContainerTV>
              <MainContainerBVOD dashboard={videoDashboardView} key={activeCampaign?.campaignId}>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                  <BVOD_KPI></BVOD_KPI>
                </div>
                {activeCampaign.authorized && (
                  <Tables>
                    <PlaceholderContainer
                      componentID={'BVOD1.1'}
                      placeholderId={'BVOD1.1'}
                      dataSources={dataSources}
                      storedQueryDetails={storedQueries.find((el) => el.position === 'BVOD1.1')}
                      isGraph={false}
                      element={{
                        type: 'Table',
                        minor: 1,
                        id: 'BVOD1.1',
                      }}
                    ></PlaceholderContainer>
                  </Tables>
                )}
                {activeCampaign.authorized && (
                  <Graphs dashboard={'BVOD'} columnsNumber={2}>
                    <PlaceholderContainer
                      componentID={'BVOD2.1'}
                      placeholderId={'BVOD2.1'}
                      dataSources={dataSources}
                      storedQueryDetails={storedQueries.find((el) => el.position === 'BVOD2.1')}
                      isGraph={true}
                      element={{
                        type: 'Chart',
                        minor: 1,
                        id: 'BVOD2.1',
                      }}
                    ></PlaceholderContainer>
                    <PlaceholderContainer
                      componentID={'BVOD2.2'}
                      placeholderId={'BVOD2.2'}
                      dataSources={dataSources}
                      storedQueryDetails={storedQueries.find((el) => el.position === 'BVOD2.2')}
                      isGraph={true}
                      element={{
                        type: 'Chart',
                        minor: 2,
                        id: 'BVOD2.2',
                      }}
                    ></PlaceholderContainer>
                  </Graphs>
                )}

                {uploadComponentsBVOD?.map((ids, index) => (
                  <AudienceReport key={index}>
                    {ids.map((id: any) => (
                      <ARContainer
                        key={id.id}
                        componentID={id.id}
                        oldComponentID={null}
                        visible={id.visible}
                        setUploadComponents={setUploadComponentsBVOD}
                        uploadComponents={uploadComponentsBVOD}
                      />
                    ))}
                  </AudienceReport>
                ))}
              </MainContainerBVOD>
            </>
          ) : (
            <>
              <MainContainerTV dashboard={videoDashboardView}>
                <>
                  <TVKPIs></TVKPIs>
                  <Graphs dashboard={'TV'} columnsNumber={4}>
                    {publishedQueries
                      .filter((el) => el?.position?.startsWith('TV1'))
                      .sort((a, b) => (Number(a.position) > Number(b.position) ? 1 : -1))
                      .map((e) => (
                        <ClientPlaceholderContainer
                          key={e.position}
                          publishedQueriesDetails={e}
                          componentID={e.position as string}
                          isGraph={true}
                        ></ClientPlaceholderContainer>
                      ))}
                  </Graphs>

                  <Graphs dashboard={'TV'} columnsNumber={2}>
                    {publishedQueries
                      .filter((el) => el?.position?.startsWith('TV2'))
                      .sort((a, b) => (Number(a.position) > Number(b.position) ? 1 : -1))
                      .map((e) => (
                        <ClientPlaceholderContainer
                          key={e.position}
                          publishedQueriesDetails={e}
                          componentID={e.position as string}
                          isGraph={true}
                        ></ClientPlaceholderContainer>
                      ))}
                  </Graphs>

                  <Tables>
                    {publishedQueries
                      .filter((el) => el?.position?.startsWith('TV3'))
                      .map((e) => (
                        <ClientPlaceholderContainer
                          key={e.position}
                          publishedQueriesDetails={e}
                          componentID={e.position as string}
                          isGraph={false}
                        ></ClientPlaceholderContainer>
                      ))}
                  </Tables>
                </>

                {componentIDs.map((ids, index) => (
                  <AudienceReport key={index}>
                    {ids.map((id) => (
                      <ARContainer key={id} componentID={id} oldComponentID={null} />
                    ))}
                  </AudienceReport>
                ))}
              </MainContainerTV>
              <MainContainerBVOD dashboard={videoDashboardView}>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                  <BVOD_KPI></BVOD_KPI>
                </div>
                {publishedQueries.length > 0 && (
                  <Tables>
                    <ClientPlaceholderContainer
                      componentID={'BVOD1.1'}
                      publishedQueriesDetails={publishedQueries.find((el) => el.position === 'BVOD1.1')}
                      isGraph={false}
                    ></ClientPlaceholderContainer>
                  </Tables>
                )}
                {publishedQueries.length > 0 && (
                  <Graphs dashboard={'BVOD'} columnsNumber={2}>
                    <ClientPlaceholderContainer
                      componentID={'BVOD2.1'}
                      publishedQueriesDetails={publishedQueries.find((el) => el.position === 'BVOD2.1')}
                      isGraph={true}
                    ></ClientPlaceholderContainer>
                    <ClientPlaceholderContainer
                      componentID={'BVOD2.2'}
                      publishedQueriesDetails={publishedQueries.find((el) => el.position === 'BVOD2.2')}
                      isGraph={true}
                    ></ClientPlaceholderContainer>
                  </Graphs>
                )}

                {/* {componentIDsBVOD.map((ids, index) => (
                  <AudienceReport key={index}>
                    {ids.map((id) => (
                      <ARContainer key={id} componentID={id} oldComponentID={null} />
                    ))}
                  </AudienceReport>
                ))} */}
              </MainContainerBVOD>
            </>
          )}
        </>
      ) : (
        <NoCampaignSelected page={'TV'}></NoCampaignSelected>
      )}
    </>
  );
};

export default TVmain;
